import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss']
})
export class AuthorizeComponent implements OnInit {

  code : string = "";
  socialRedirection: any = "";

  constructor(private activatedRoute: ActivatedRoute,
    private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    private ngxLoader: NgxUiLoaderService,private router: Router,
    private appService: AppService) { }

  ngOnInit() {
    this.socialRedirection = this.storageService.getItem('socialRedirection');
    this.authorizeCode();
  }


  authorizeCode(){
    let reqData = {
      code : this.activatedRoute.snapshot.queryParams.code
    }
    this.appService.postRequest(API.FAN_AUTH, reqData).subscribe(result => {
      if (result && result.status == 0) {
        let userInfo = result.user;
        userInfo.signedIn = true;
        userInfo.access_token = userInfo.session_token;
        let isAffiliateUser = userInfo.referral_code ? true : false;
        this.storageService.setItem("isAffiliateUser", isAffiliateUser);
        this.storageService.setItem("user_Info", { access_token : userInfo.access_token });
        this.storageService.setItem("affiliateReferralCode", userInfo?.referral_code);

        localStorage.isFanLoginUser = true;
        // if(userInfo && userInfo.user_phone_number && userInfo.date_of_birth
        //    && userInfo.user_display_name) {
            userInfo.is_profile_completed = true;
            this.commanSubscribeService.sendUserInfo(userInfo);
            if (this.socialRedirection) {
              this.storageService.deleteItem('socialRedirection');
              this.router.navigateByUrl(this.socialRedirection);
            } else {
              this.router.navigateByUrl('/' + this.storageService.getItem('channelName'));
            }
        // } else {
        //   userInfo.is_profile_completed = false;
        //   this.commanSubscribeService.sendUserInfo(userInfo);
        //   this.router.navigateByUrl(`/user-dashboard/profile-settings/basic-info`);
        // }
      }
    }, error => {
      this.ngxLoader.stop();
      this.router.navigateByUrl("");
    });
  }

}
